import { Link } from 'react-router-dom'
import { SectionLabel } from '../ui/SectionLabel'

interface SafetyAlertCardProps {
  openReports: number
}

/** Amber safety-alert card shown on the parent home when an open report exists (DESIGN §3.1). */
export function SafetyAlertCard({ openReports }: SafetyAlertCardProps) {
  if (openReports <= 0) return null
  return (
    <div className="rounded-card border border-honey-chip bg-honey-bg p-5">
      <SectionLabel className="text-honey-fg">Safety</SectionLabel>
      <p className="mt-2 text-[13.5px] leading-relaxed text-honey-fg">
        {openReports} report{openReports === 1 ? ' is' : 's are'} with a moderator.
      </p>
      <Link
        to="/safety"
        className="mt-3 inline-flex items-center gap-1 text-[13px] font-medium text-honey-fg underline"
      >
        Open safety centre →
      </Link>
    </div>
  )
}
